import { useState, useEffect, createContext, useContext } from "react";
import axiosInstance from "../api/axiosConfig";

// Create Auth Context
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Reusable fetch user function
  const fetchUser = async () => {
    try {
      setLoading(true);

      const token = localStorage.getItem("token");
      if (!token) {
        setUser(null);
        setLoading(false);
        return;
      }

      const response = await axiosInstance.get("/doctor/me");

      if (response.data?.data) {
        setUser(response.data.data);
        console.log(
          "User loaded:",
          response.data.data.fullName,
          "staffRole:",
          response.data.data.staffRole
        );
      } else {
        setUser(null);
      }
    } catch (error) {
      console.error("Error fetching user:", error);

      if (error.response?.status === 401) {
        localStorage.removeItem("token");
      }

      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  // Fetch current user on mount
  useEffect(() => {
    fetchUser();
  }, []);

  const hasRole = (allowedRoles) => {
    if (!user || !user.staffRole) return false;
    return allowedRoles.includes(user.staffRole);
  };

  const canAccess = (feature) => {
    const permissions = {
      dashboard: ["owner", "admin", "manager", "member"],
      patients: ["owner", "admin", "manager", "member"],
      appointments: ["owner", "admin", "manager", "member"],

      payments: ["owner", "admin", "manager"],
      invoices: ["owner", "admin", "manager"],
      orders: ["owner", "admin", "manager"],
      services: ["owner", "admin", "manager"],
      medicine: ["owner", "admin", "manager"],

      professionals: ["owner", "admin"],
      facility: ["owner", "admin"],
      staffs: ["owner", "admin"],
      campaigns: ["owner", "admin"],
      settings: ["owner", "admin"],
    };

    const allowedRoles = permissions[feature];
    if (!allowedRoles) return false;
    return hasRole(allowedRoles);
  };

  return (
    <AuthContext.Provider
      value={{ user, setUser, loading, hasRole, canAccess, fetchUser }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export default useAuth;